const navs = [
    { name: "labels.bridges", url: "/asset-management/containers/", icon: "dumpster", role: "tech" },
    { name: "labels.devices", url: "/asset-management/devices/", icon: "network-wired", role: "admin" },
    { name: "labels.device-groups", url: "/asset-management/device_groups/", icon: "object-ungroup", role: "admin" },
    { name: "labels.import", url: "/asset-management/imports/", icon: "file-import", role: "admin" },
    { name: "labels.export", url: "/asset-management/exports/", icon: "file-export", role: "admin" }
]

export default navs